import React from "react";
import banner from "../../assets/12_Quienes somos/Sobre nosotros/sobre-nosotros-banner-hb20-vista-lateral-trasera.webp";

/*eslint-disable */

declare const window: any;
const BannerComponent: React.FC = () => {
  return (
    <div
      className="banner-quienes-somos-component"
      style={{ backgroundImage: `url(${banner})` }}
    >
      {/* H1 - Título principal de la página */}
      <h1 className="mascara-banner-quienes-somos-component">
        Saber elegir, es Hyundai
      </h1>
    </div>
  );
};

export default BannerComponent;